import { formatDateString } from "@redotech/redo-merchant-fulfillment-app/utils/outbound-labels-utils";
import {
  DateComparisonOperator,
  dateComparisonToLabel,
} from "@redotech/redo-model/advanced-flow/expressions/date-expression";
import { Text } from "@redotech/redo-web/text";

export function DateComparisonDetails({
  field,
  matchType,
  matchDate,
}: {
  field: string;
  matchType?: DateComparisonOperator;
  matchDate?: Date;
}) {
  const matchTypeLabel: string | undefined = matchType
    ? dateComparisonToLabel[matchType]
    : undefined;

  return (
    <>
      <Text fontWeight="semibold">{field}</Text>
      <Text>{" is"}</Text>
      {matchType ? ` ${matchTypeLabel}` : undefined}
      {matchDate ? (
        <Text fontWeight="semibold">
          {matchDate
            ? ` ${formatDateString(matchDate.toISOString(), true)}`
            : undefined}
        </Text>
      ) : undefined}
    </>
  );
}
